import { getLoggedInNumber } from '@airtel-lego/native-app-bridge';
import { encodeData, getFromSessionStorage } from '@airtel/air-utils';
import axios from '@airtel/air-artist/lib/axios/index';
import { getQueryString, LOGIN_CONSTANTS } from '../constants/AppConstants';

/**
 * check if local storage is supported or not
 * @returns {boolean}
 */
export const isLocalStorageSupported = () => {
   const testKey = 'test';
   try {
      const storage = window.localStorage;
      storage.removeItem(testKey);
      return true;
   } catch (error) {
      // fireApiErrorLogSentry(
      //    'utils.ts-->isLocalStorageSupported-->error while checking if Local Storage is Supported',
      //    error
      // );
      return false;
   }
};

/*
 * generic function to return whether a user is logged in or not
 * @returns {boolean}
 */
export const isUserLoggedIn = () => {
   if (isLocalStorageSupported()) {
      if (
         localStorage?.getItem(LOGIN_CONSTANTS.dynamicToken) !== null &&
         localStorage?.getItem(LOGIN_CONSTANTS.uid) !== null &&
         localStorage?.getItem(LOGIN_CONSTANTS.staticToken) !== null &&
         localStorage?.getItem(LOGIN_CONSTANTS.loggedInUser) !== null
      ) {
         return true;
      }
   }
   return false;
};

export const onLoginSuccessCallback = (data: any, setIsLoggedIn: any) => {
   if (isLocalStorageSupported()) {
      localStorage?.setItem(LOGIN_CONSTANTS.dynamicToken, data?.dynamicToken);
      localStorage?.setItem(LOGIN_CONSTANTS.uid, data?.uid);
      localStorage?.setItem(LOGIN_CONSTANTS.staticToken, data?.staticToken);
      localStorage?.setItem(LOGIN_CONSTANTS.loggedInUser, encodeData(data?.loggedInUser));
      setIsLoggedIn(true);
   }
};

export const onApiError = (error: any, onAuthFailHandler: any) => {
   if (
      error?.response?.status === 403 ||
      error?.response?.data === 'UNAUTHORIZED -- invalid token'
   ) {
      if (isLocalStorageSupported()) {
         localStorage?.removeItem(LOGIN_CONSTANTS.dynamicToken);
         localStorage?.removeItem(LOGIN_CONSTANTS.uid);
         localStorage?.removeItem(LOGIN_CONSTANTS.staticToken);
         localStorage?.removeItem(LOGIN_CONSTANTS.loggedInUser);
         onAuthFailHandler();
      }
   }
};

// to fire dynamic event for chatbot on thanks app
export const fireDynamicEvents = async (
   siNumber: string,
   state: string,
   pageName: string,
   price?: string
) => {
   try {
      const journeyType = JSON.parse(getFromSessionStorage('journeyType') || '{}');
      const { price, utm_source } = getQueryString();
      if (journeyType?.journey === 'P2P') {
         getLoggedInNumber().then((appNumber) => {
            if (appNumber) {
               const data: any = {
                  utmSource: utm_source || '',
                  rtn: appNumber,
                  siNumber,
                  journeyName: 'PRE_TO_POST',
                  timestamp: new Date().toISOString(),
                  pageDetails: {
                     id: pageName,
                     state, // PAGE_LOAD, OTP_VERIFIED
                  },
               };
               // pass pack id on thanks page
               if (price) data.pageDetails.price = price;
               const isProduction = window?.location?.origin?.includes('www.airtel.in');
               const url = isProduction
                  ? 'https://digi-api.airtel.in/bot-engine/user/activity'
                  : 'https://kongqa.airtel.com/bot-engine/user/activity';
               axios({
                  url,
                  data,
                  method: 'POST',
                  headers: {
                     'Content-Type': 'application/json',
                  },
               }).catch((e: any) => {
                  console.error('Error while firing dynamic event for chatbot', e);
               });
            }
         });
      } else {
         console.warn('>>>>> THIS IS NOT P2P PAGE FLOW PAG'); // if not p2p then don't fire event
      }
   } catch (error) {
      console.error('>>>>> try catch', error);
   }
};
